import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import Swal from '../../../shared/utils/swal.util';
import { AuthService } from 'app/core/services/auth/auth.service';
import { MunicipioService } from 'app/core/services/sai/core/municipio/municipio-service.service';
import { EstadoService } from 'app/core/services/sai/core/estado/estado-service.service';
import { Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Estado } from 'app/core/dtos/sai/core/estado';
import { Municipio } from 'app/core/dtos/sai/core/municipio';
import { AtrDadosService } from 'app/core/services/sai/controladoria/atr-dados/atr-dados.service';
import { AtrDadosDimensoesPorMunicipio, GetAtrDadosDimensoesPorMunicipio } from 'app/core/dtos/sai/controladoria/atr-dados-dimensoes-por-municipio';
import { FormControl } from '@angular/forms';
import { distinct, map, Observable, startWith } from 'rxjs';
import { SearchService } from 'app/shared/utils/search.service';
import { UnsubscribeOnDestroyAdapter } from 'app/shared';

@Component({
  selector: 'app-navbar-atricon',
  standalone: false,
  templateUrl: './navbar-atricon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './navbar-atricon.component.css'
})
export class NavbarAtriconComponent extends UnsubscribeOnDestroyAdapter implements OnInit {
  estado: Estado[] = [];
  municipio: Municipio[] = [];
  codEstadoEst?: number;
  codMunicipioMun?: number;
  dimensoesPorMunicipio: AtrDadosDimensoesPorMunicipio[] = [];
  countAlerta: number = 0;
  darkmode = false;
  selectedColor: string = "";
  desNomeOrg?: string;

  @Output() scrollToItem = new EventEmitter<string>();

  constructor(private readonly authService: AuthService,
    private readonly municipioervice: MunicipioService,
    private readonly estadoService: EstadoService,
    private readonly atrDadosService: AtrDadosService,
    private readonly router: Router,
    private readonly cd: ChangeDetectorRef,
    private readonly searchService: SearchService) {
      super();
  }

  ngOnInit(): void {
    this.darkmode = document.documentElement.getAttribute('data-mode') === 'dark';
    this.selectedColor = document.documentElement.getAttribute('data-theme') ?? '';

    this.authService.currentUser.subscribe(user => {
      if (user?.idOrgao && user?.idTipoOrgao && user?.idPerfil) {
        this.desNomeOrg = this.authService.currentUserValue?.orgao;
      }
    });
    this.getEstados();
    this.getDadosOrgao();
    this.filteredPerguntas = this.perguntaControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || ''))
    );
  }

  perguntaControl = new FormControl('');
  perguntas: string[] = [];
  filteredPerguntas!: Observable<string[]>;

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.perguntas.filter(option =>
      option.toLowerCase().includes(filterValue)
    );
  }

  onSelect(pergunta: string) {
    this.scrollToItem.emit(pergunta);
  }

  onSearch(term: string) {
    this.searchService.sendSearchTerm(term);
  }


  getDadosOrgao() {
    this.atrDadosService.getDados().subscribe({
      next: (response) => {
        if (response.success) {
          this.perguntas = (Array.from(
            [...new Set(response.data.map(d => d.desDimensao.trim() || ''))]
          ));
        }
      },
      error: (error) => {
      },
      complete: () => {
      }
    });
  }


  modetoggle() {
    this.darkmode = !this.darkmode;
    const mode = this.darkmode ? 'dark' : 'light';
    document.documentElement.setAttribute('data-mode', mode);
    localStorage.setItem('sai_adm_mode', mode);
    const button = document.getElementById('dark');
    if (button) {
      button.title = this.darkmode ? 'Modo claro' : 'Modo escuro';
    }
  }

  setColor(color: string) {
    this.selectedColor = color.replace(/Theme$/, '').toLowerCase();

    if (this.selectedColor && this.selectedColor !== 'light') {
      document.documentElement.setAttribute('data-theme', this.selectedColor);
      localStorage.setItem('sai_adm_theme', this.selectedColor);
    } else {
      document.documentElement.removeAttribute('data-theme');
      localStorage.removeItem('sai_adm_theme');
    }
  }

  getEstados() {
    this.estadoService.getAll()
      .subscribe(
        {
          next: (response) => {
            this.estado = response.data;
          },
          error: (error) => {
          },
          complete: () => {
          }
        }
      );
  }

  getMunicipios() {
    Swal.fire({
      title: 'Carregando municípios...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    this.municipioervice.getMunicipioByEstado(this.codEstadoEst!)
      .subscribe(
        {
          next: (response) => {
            this.municipio = response.data;
          },
          error: (error) => {
          },
          complete: () => {
            this.cd.detectChanges();
            Swal.close();
            setTimeout(() => {
              const dropdownBtn = document.querySelector('.dropdown-btn');
              if (dropdownBtn) {
                (dropdownBtn as HTMLElement).click();
              }
            }, 100);
          }
        }
      );
  }

  getAtrDadosPorMunicipio() {
    Swal.fire({
      title: 'Carregando dados do orgão...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    let atrGetDadosDimensoes: GetAtrDadosDimensoesPorMunicipio = {
      itemAvaliacao: 'Disponibilidade',
      codMunicipioMun: this.codMunicipioMun!
    };

    this.atrDadosService.getDimensoesPorMunicipio(atrGetDadosDimensoes)
      .subscribe(
        {
          next: (response) => {
            this.dimensoesPorMunicipio = response.data;
          },
          error: (error) => {
          },
          complete: () => {
            this.countAlertas();
            this.cd.detectChanges();
            Swal.close();
            setTimeout(() => {
              const dropdownBtn = document.querySelector('.dropdown-btn');
              if (dropdownBtn) {
                (dropdownBtn as HTMLElement).click();
              }
            }, 100);
          }
        }
      );
  }

  countAlertas() {
    this.countAlerta = this.dimensoesPorMunicipio
      .reduce((total, d) => total + (d.dimensoesNaoAtendidas || 0), 0);
  }

  onChangeEstado() {
    if (this.codEstadoEst !== undefined && this.codEstadoEst !== null) {
      this.getMunicipios();
    }
  }

  onMunicipioChange() {
    if (this.codMunicipioMun !== undefined && this.codMunicipioMun !== null) {
      this.getAtrDadosPorMunicipio();
    }
  }

  confirmChangeOrgao(codOrgaoOrg: number, desNomeOrg: string) {
    Swal.fire({
      title: `Deseja trocar para o órgão ${desNomeOrg}?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.isConfirmed) {
        this.changeOrgao(codOrgaoOrg);
      }
    });
  }

  changeOrgao(codOrgaoOrg: number) {
    Swal.fire({
      title: 'Carregando...',
      text: 'Por favor, aguarde enquanto alteramos o orgao.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    this.authService.changeOrgao(codOrgaoOrg).subscribe({
      next: () => {
        Swal.close();

        // const currentUrl = this.router.url;
        // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        //   this.router.navigate([currentUrl]);
        // });
      },
      error: (ex) => {
        Swal.close();
      }
    });
  }

  customSearchEstado(term: string, item: any) {
    term = term.toLowerCase();
    return item.desNomeEstadoEst.toLowerCase().includes(term);
  }

  customSearchMunicipio(term: string, item: any) {
    term = term.toLowerCase();
    return item.desNomeMun.toLowerCase().includes(term);
  }

  changeToFirstOrgao() {
    if (this.dimensoesPorMunicipio && this.dimensoesPorMunicipio.length > 0) {
      this.changeOrgao(this.dimensoesPorMunicipio[0].codOrgaoOrg);
    }
    else {
      Swal.fire({
        title: 'Alerta',
        icon: 'warning',
        text: 'Nenhum Orgão Encontrado.',
        allowOutsideClick: false
      });
    }
  }

  logout() {
    this.subs.sink = this.authService.logout().subscribe((res) => {
      if (!res.success) {
        this.router.navigate(['/authentication/signin']);
      }
    });
  }
}
